import React, { useState, useEffect } from "react";
import "../styles/Login.css";
import Alert from "../components/Alert";

const Login = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("reason") === "expired") {
      setError("Session expired. Please log in again.");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (res.ok) {
        setMessage("Check your email for the login link!");
      } else {
        const data = await res.json();
        setError(data.error || "Login failed. Please check your email and try again.");
      }
    } catch (err) {
      setError(err.message || "Server not available. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="bg-blob bg-blob-1"></div>
      <div className="bg-blob bg-blob-2"></div>

      <div className="login-container">
        <div className="logo-container">
          <img src="/images/StoryWeaverLogo.svg" alt="Story Weaver Logo" />
          <div className="logo">Story Weaver</div>
        </div>

        <div className="subtitle">Discover, create and share your story!</div>

        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="input-group">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              required
              disabled={loading}
            />
          </div>
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Sending..." : "Send Magic Link"}
          </button>
        </form>

        <Alert type="success" message={message} style={{ marginTop: '1.5rem', width: '100%' }} />
        <Alert type="error" message={error} style={{ marginTop: '1.5rem', width: '100%' }} />
      </div>
    </div>
  );
};

export default Login; 